export default {
  titleTips:'Friendly reminder',
  unsubscribe:'unsubscribe',
  unsubscribeTips:'No unsubscribe information available',
  emailTips:'Missing email address',
  unsubscribeConfirm:'Are you sure you want to unsubscribe?',
  confirm:'Confirm',
  cancel:'Cancel',
  unsubscribeSuccessful:'Unsubscribe Successful',
  unsubscribeFailed:'Unsubscribe Failed',
  canceled:'Canceled',
  type:'Email Type',
  unsubscribed:'Unsubscribed',
  errorEmail:'The current email address is incorrect. Please contact BD.',
};